import { render } from "./HalloweenTheme.vue?vue&type=template&id=70234d3a&scoped=true"
import script from "./HalloweenTheme.vue?vue&type=script&lang=js"
export * from "./HalloweenTheme.vue?vue&type=script&lang=js"

import "./HalloweenTheme.vue?vue&type=style&index=0&id=70234d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70234d3a"]])

export default __exports__